import { render } from "./AggregatorsPage.vue?vue&type=template&id=d07ab114&scoped=true&ts=true"
import script from "./AggregatorsPage.vue?vue&type=script&lang=ts"
export * from "./AggregatorsPage.vue?vue&type=script&lang=ts"

import "./AggregatorsPage.vue?vue&type=style&index=0&id=d07ab114&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d07ab114"]])

export default __exports__